import * as eff from 'redux-saga/effects';
import createActionCreators from 'redux-resource-action-creators';

import {
  throwError,
} from './helpers';
import api from '../api';
import {
  actionTypes,
  requestFetchClients,
  requestFetchClientEntity,
} from '../actions';

export function normalizeLibrary(library) {
  const resourceTypes = {
    Documents: 'documents',
    'Warmup Templates': 'warmups',
    'Cooldown Templates': 'cooldowns',
    Exercises: 'exercises',
    'Workout Templates': 'workoutTemplates',
    'Program Templates': 'programTemplates',
  };

  const {
    items: rootChildrens,
    ...rootFolder
  } = library[0];

  const normalizeLibraryResource = items => (
    items.reduce(
      (acc, item) => {
        const {
          items: childrens,
          ...lib
        } = item;
        let folders = [];
        let resources = [];
        if (childrens && childrens.length) {
          ({
            folders,
            resources,
          } = normalizeLibraryResource(childrens));
        }
        return {
          folders: [
            ...acc.folders,
            ...(
              lib.parent_id !== undefined
                ? [lib]
                : []
            ),
            ...folders,
          ],
          resources: [
            ...acc.resources,
            ...(
              lib.parent_id === undefined
                ? [lib]
                : []
            ),
            ...resources,
          ],
        };
      },
      {
        folders: [],
        resources: [],
      },
    )
  );

  const normalizedLibrary = (
    rootChildrens.reduce((acc, item) => {
      const {
        items,
        ...folder
      } = item;
      const {
        resources,
        folders,
      } = normalizeLibraryResource(items);
      return {
        ...acc,
        [resourceTypes[folder.name]]: resources,
        folders: [
          ...acc.folders,
          {
            ...folder,
            is_root: true,
            is_warmap: folder.name === 'Warmup Templates',
            is_cooldown: folder.name === 'Cooldown Templates',
          },
          ...folders,
        ],
      };
    },
    {
      folders: [
        rootFolder,
      ],
      /* TODO: warmups and cooldowns probably stores in workout templets db, */
      /* so maybe it's better to store it in workouts  */
      warmups: [],
      cooldowns: [],
      documents: [],
      exercises: [],
      workoutTemplates: [],
      programTemplates: [],
    })
  );
  const {
    folders: resources,
    ...includedResources
  } = normalizedLibrary;

  return {
    resources,
    includedResources,
    multiLists: {
      folders: {
        roots: rootChildrens.map(f => f.id),
      },
    },
    customLists: {
      warmups: 'library',
      documents: 'library',
      cooldowns: 'library',
      exercises: 'library',
      workoutTemplates: 'library',
      programTemplates: 'library',
    },
  };
}

export default function* initialProResources() {
  function* fetchLibrary() {
    const actions = createActionCreators('read', {
      resourceType: 'folders',
      requestKey: 'fetchLibrary',
    });

    try {
      yield eff.put(actions.pending());
      const library = yield eff.call(
        api.getLibrary,
      );

      const normalized = normalizeLibrary(library);

      yield eff.put(actions.succeeded(normalized));
    } catch (err) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, err);
    }
  }

  function* fetchClientGroups() {
    const actions = createActionCreators('read', {
      resourceType: 'clientGroups',
      requestKey: 'fetchClientGroups',
    });

    try {
      yield eff.put(actions.pending());

      const resources = yield eff.call(
        api.getClientGroups,
      );

      yield eff.put(actions.succeeded({
        resources,
      }));
    } catch (err) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, err);
    }
  }

  function* fetchPersonalProperties() {
    const actions = createActionCreators('read', {
      resourceType: 'personalProperties',
      requestKey: 'fetchPersonalProperties',
    });

    try {
      yield eff.put(actions.pending());

      const resources = yield eff.call(
        api.getPersonalProperties,
      );

      yield eff.put(actions.succeeded({
        resources,
      }));
    } catch (err) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, err);
    }
  }

  function* fetchTags() {
    const actions = createActionCreators('read', {
      resourceType: 'tags',
      requestKey: 'fetchTags',
    });

    try {
      yield eff.put(actions.pending());

      const resources = yield eff.call(
        api.getEntity,
        {
          type: 'tags',
        },
      );

      yield eff.put(actions.succeeded({
        resources,
      }));
    } catch (err) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, err);
    }
  }

  yield eff.fork(fetchLibrary);
  yield eff.fork(fetchClientGroups);
  yield eff.fork(fetchTags);
  yield eff.fork(fetchPersonalProperties);

  // Fetch product and plas
  yield eff.put(
    requestFetchClients({
      resourceType: 'clients',
    }),
  );

  // Fetch product and plans
  yield eff.put(
    requestFetchClientEntity({
      resourceType: 'products',
    }),
  );
  yield eff.put(
    requestFetchClientEntity({
      resourceType: 'productPlans',
    }),
  );

  // fetch assigned workouts
  yield eff.put(
    requestFetchClientEntity({
      list: 'me',
      resourceType: 'personalWorkouts',
    }),
  );

  // fetch stripe customer
  yield eff.put({
    type: actionTypes.REQUEST_CURRENT_CUSTOMER,
  });
  yield eff.put({
    type: actionTypes.REQUEST_GET_PAYMENT_METHODS,
  });

  // fetch unread message count
  yield eff.put({ type: actionTypes.REQUEST_UNREAD_COUNT });
}
